//@author: devin
import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Item } from "../../../pojo/Item";
import { ResourceTooltipResponse } from "../../../services/tooltip.service";
import { S25ItemTooltip } from "./s25.item.tooltip.directive";

@TypeManagerDecorator("s25-resource-tooltip")
@Component({
    selector: "s25-resource-tooltip",
    template: `
        @if (!loaded()) {
            Loading...
        } @else if (!item()) {
            Could not load resource details
        } @else {
            <div class="boxHeader">
                <div class="boxHeaderName">{{ item()!.name }}</div>
            </div>
            <div class="boxBody">
                @if (categoriesString()) {
                    <span class="c-dataLabel">Categories: </span>
                    <span>
                        {{ categoriesString() }}
                    </span>
                }
            </div>
        }
    `,
    host: {
        "[class.resourceBox]": "loaded()",
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25ResourceTooltip extends S25ItemTooltip<ResourceTooltipResponse> {
    readonly categoriesString = computed(() => {
        const item = this.item();
        if (!item) {
            return undefined;
        } else if ("categoryList" in item) {
            return (item.categoryList ?? []).join("; ");
        } else if ("categories" in item) {
            // Add space after semicolons if missing
            return item.categories.replace(/(\w);(\w)/g, "$1; $2");
        }
    });
}
